import { Ghost } from "lucide-react";
import { PropagateLoader, RotateLoader } from "react-spinners";

const loadingQuotes = [
        //borderlands
        "These pretzels suck",
        // brooklyn nine nine
        "There are no highlights in Scottsdale, Margo",
        "BOOOONNNEEEE?!",
        "Yippee kayak other buckets! ",
        "I once sold a man a fake Pekingese. 'Twas a cat.",
        "Bigpot!",
        //superstore
        "That’s too much juice Glenn!",
        "What's the biggest dog you've ever seen and why?",
        //new girl
        "You gave me cookie I got you cookie!",
        "Are you the criminals? From the statistics?!?",
        "You need Bobby’s pins to put your hair back?",
        "YOUTHES!",
        "I hate when Schmidt cries. he sounds like a ghost singing Hey Ya" ,
        //family guy
        "Peter, the horse is here",
        //adventure time
        "We can rule them like gods, angry gods",
        "I have approximate knowledge of many things",
        "Lets kill the horse",
        "Work and fun don't mix, unless you're a clown.",
        "Man, Ice King, you better roll on. ",
        "Your constant harassment of the female gender makes me sickkk",
        //arrested development
        "Why are you blue",
        "There's always money in the banana stand",
        "Steve Holt!",
        "OH MY GOD WE ARE HAVING A FIRE... sale",
        //archer
        "Lana. LANA. LAAAANNNNAAA!! ",
        "Phrasing!",
        "Grill me a cheese!",
        "Serpentine, Baboo!",
        //community
        "I don't have an ego. My Facebook photo is a landscape",
        "Never listen to Pierce.",
        "It's called chemistry, I have it with everybody!",
        "Some flies are too awesome for the wall.",
        "A passing grade? Like a C? Why don't I just get pregnant at a bus station!?",
        "That was a game. This is paintball.",
        "Put it in a letter, Jane Austen!",
        "Kettle corn?! That's a fun time snack!",
        "Sometimes I think I lost something really important to me, and then it turns out I already ate it.",
        "Oh, Britta's in this?",
        "Fire can't go through doors, stupid. It's not a ghost.",
        "Consider yourself Chang'd!",
        "I was so unpopular in high school, the crossing guard used to lure me into traffic.",
        //mob psycho
        "SALT SPLASH",
        //transformers
        "Kitten calendar, kitten calendar, kitten calendar, kitten calendar "
    ] 


export default function MainLoader () {
    return(
        <div className="flex gap-10 flex-col justify-center items-center w-full h-full ">
            <PropagateLoader color="#ffffff"></PropagateLoader>
            <p className="text-neutral-200  text-sm italic text-center ">
                { loadingQuotes[Math.floor(Math.random()*loadingQuotes.length)] }
            </p>
        </div>
        
    )
}

export function SecondaryLoader () {
    return(
        <div className="flex pt-10 justify-center items-center w-full h-full ">
            <RotateLoader color="#ffffff" size={12} speedMultiplier={0.75}></RotateLoader>
        </div>
        
    )
}

export function ErrorResponse(title:string = "page"){
    return(
        <main className="flex flex-col h-2/3 gap-2 justify-center items-center text-center text-white mt-15 font-semibold">
            <h3 className="text-xl sm:text-2xl"> Something went wrong loading {title} :/</h3>
            <p className="text-neutral-600 font-medium">We may be expierencing issues, try again later</p>
            <Ghost className="mt-5 w-10 h-10 text-neutral-700" />
        </main>
    )
}